import React from 'react';
import { SvgIcon } from 'components/SvgIcon';
import { enNormalizedPaymentType } from 'enums/enPaymentMethod';

interface IProps {
  paymentMethod: enNormalizedPaymentType;
}

const Messages = (props: IProps) => {
  switch (props.paymentMethod) {
    case enNormalizedPaymentType.BANKSLIP:
      return (
        <div>
          <h2 id='title-thankyou'>Seu boleto está pronto!</h2>
          <h3 id='subtitle-thankyou'>Agora é só pagar seu boleto para receber o produto</h3>
        </div>
      );
    case enNormalizedPaymentType.FREE:
      return (
        <div>
          <h2 id='title-thankyou'>Nós amamos produtos grátis!</h2>
          <h3 id='subtitle-thankyou'>Estamos preparando tudo para você</h3>
        </div>
      );
    default:
      return (
        <div>
          <h2 id='title-thankyou'>Excelente Compra!</h2>
          <h3 id='subtitle-thankyou'>Confirme os dados da sua compra</h3>
        </div>
      );
  }
};

export const Header = (props: IProps) => (
  <div className={'header'}>
    <div className={'icon'}>
      <SvgIcon name='check' />
    </div>
    <Messages paymentMethod={props.paymentMethod} />
  </div>
);